

































































import { Integration } from '@/types/Tenant.interface'
import Vue from 'vue'
import ProgressSpinner from '@/components/ProgressSpinner.vue'
import { mapGetters } from 'vuex'
export default Vue.extend({
    components: { ProgressSpinner },
    data: () => ({
        loading: false
    }),
    computed: {
        ...mapGetters(['isSphere', 'integrations']),
        connectionColor(): string {
            return this.isSphere ? 'primary--text' : 'grey--text'
        },
        customerIdColor(): string {
            return this.isSphere ? 'primary--text' : 'grey--text'
        },
        defaultId: {
            get(): void {
                //  Search the sphere_ids to find the default and return the id value
                const defaultItem = this.sphereCustomerIds.find(
                    (item) => item.default === true
                )

                //  If we found a default item, return it
                if (defaultItem) return defaultItem.id

                //  Else, return null
                return null
            },
            set(value): void {
                if (value) {
                    //  Set the default sphere_id
                    this.sphereIntegration.forEach((item) => {
                        if (item.data.id === value) {
                            item.data.default = true
                        } else {
                            item.data.default = false
                        }

                        //  Save the setting
                        this.$store.dispatch('integrationsPut', item)
                    })
                }
            }
        },
        sphereCustomerIds(): Integration[] {
            //  IF we have no integrations, return null
            if (!this.sphereIntegration || !this.sphereIntegration.length) return []

            //  Return our integration data
            return this.sphereIntegration.map((x) => x.data)
        },
        sphereIntegration(): Integration {
            //  If no integrations, return null
            if (!this.integrations) return null

            //  Else, find our sphere integrations
            const integration = this.integrations.filter((x) => x.name === 'sphere')

            //  Return our integrations
            return integration
        }
    },
    methods: {
        add(): void {
            //  Push a new sphere_id to the array
            this.sphereCustomerIds.push({
                id: null,
                default: this.sphereCustomerIds.length == 0 ? true : false,
                editing: true
            })

            //  We have to force update so the client reflects the changes
            this.$forceUpdate()
        },
        async post(index: number): Promise<void> {
            //  Create our payload (set editing to false so we close it)
            const payload = {
                name: 'sphere',
                enabled: true,
                data: { ...this.sphereCustomerIds[index], editing: false }
            }

            //  Start the loading spinner
            this.loading = true

            //  Create our integration
            await this.$store.dispatch('integrationsPost', payload)

            //  Stop the loading spinner
            this.loading = false
        },
        async remove(index: number): Promise<void> {
            //  Get the integration id
            const id = this.sphereIntegration[index].id

            //  Start the loading spinner
            this.loading = true

            //  Save the integration
            await this.$store.dispatch('integrationsDelete', id)

            //  Stop the loading spinner
            this.loading = false
        },
        async save(index: number): Promise<void> {
            //  Validate that all fields are filled
            const valid = await this.$validator.validateAll()

            //  If invalid, do nothing
            if (!valid) return

            //  If this index is > our integration length, we are posting a new one
            if (index >= this.sphereIntegration.length) this.post(index)
            //  Else, update an existing
            else this.update(index)
        },
        async update(index: number): Promise<void> {
            //  Else, remove the 'editing' flag from the id
            this.sphereIntegration[index].data.editing = false

            //  Start the loading spinner
            this.loading = true

            //  Save the integration
            await this.$store.dispatch('integrationsPut', this.sphereIntegration[index])

            //  Stop the loading spinner
            this.loading = false
        }
    }
})
